import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { services } from "@/data/services";

/**
 * Home page services grid. Pure presentation; reads its own data so the page
 * component stays a thin composition root.
 */
export function HomeServices({ t, lang }) {
  return (
    <section className="max-w-[1120px] mx-auto px-4 sm:px-6 mt-12">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h2 className="text-2xl sm:text-3xl font-semibold text-[hsl(var(--brand-navy))]">{t("home.services_title")}</h2>
          <p className="text-sm sm:text-base text-[hsl(var(--muted-foreground))] mt-1 max-w-prose">{t("home.services_sub")}</p>
        </div>
        <Link to="/servizi" className="text-sm font-medium text-[hsl(var(--brand-aqua))] hover:underline shrink-0">{t("common.view_all")}</Link>
      </div>
      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="home-services-grid">
        {services.map((s) => {
          const Icon = s.icon;
          return (
            <Card key={s.key} className="p-4 card-hover border-[hsl(var(--border))]">
              <div className="flex items-center gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[hsl(var(--accent))] text-[hsl(var(--brand-aqua))]">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="text-base font-semibold text-[hsl(var(--brand-navy))]">{lang === "it" ? s.title_it : s.title_en}</h3>
              </div>
              <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))]">{lang === "it" ? s.short_it : s.short_en}</p>
            </Card>
          );
        })}
      </div>
    </section>
  );
}

export default HomeServices;
